import { T } from "react-translator-component";

/** Parsea settings de opción (objeto o JSON string). */
export function parseOptionSettings(rawSettings) {
    if (!rawSettings) return null;
    if (typeof rawSettings === "string") {
        try {
            return JSON.parse(rawSettings);
        } catch {
            return null;
        }
    }
    if (typeof rawSettings === "object") return rawSettings;
    return null;
}

/** True si una opción tiene configuración real (questions no vacío). */
export function hasSettingsQuestions(option) {
    const parsed = parseOptionSettings(option?.settings);
    return Boolean(parsed?.questions && Array.isArray(parsed.questions) && parsed.questions.length > 0);
}

/** Indica si settings tiene baremo (prices con valores). settings puede ser objeto o JSON string. */
export function hasBaremo(settings) {
    if (!settings) return false;
    const s = parseOptionSettings(settings);
    const prices = s?.prices;
    if (!prices || typeof prices !== "object") return false;
    for (const key of Object.keys(prices)) {
        const arr = prices[key];
        if (Array.isArray(arr) && arr.some(v => typeof v === "number" || (typeof v === "string" && !Number.isNaN(Number(v))))) return true;
    }
    return false;
}

/** Devuelve true si no debe mostrarse el precio (oculto, baremo en cup o en opciones). */
export function shouldHidePrice(cup) {
    if (!cup) return false;
    if (cup.priceHidden) return true;
    if (hasBaremo(cup.settings)) return true;
    if (cup.options?.length && cup.options.some(opt => hasBaremo(opt.settings))) return true;
    return false;
}

/** Etiqueta "Desde" para precios (usa T('general.from')). */
export function getFromPriceLabel() {
    const t = T("general.from");
    return (typeof t === "string" ? t : "Desde").trim();
}
